<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="card-part pt-0">
        <div class="txt-head black--text d-flex justify-space-between mb-3">
          <div>
            <span class="theme-color-one">ส่วนที่ 5 :</span> เอกสารแนบ
          </div>
          <Button
              theme="6"
              :disabled="isOIC"
              @onClick="addAttachment"
          >
            + เพิ่มไฟล์
          </Button>
        </div>

        <!-- Form 1 -->
        <div v-if="!isOIC">
          <div class="theme-color-seven mb-3">
            *ไฟล์ที่ระบบรองรับ .PDF/.doc (สูงสุด 50 MB/ไฟล์)
          </div>

          <v-layout class="mt-3" v-for="(file, f) in attachment" :key="f">
            <v-flex xs7>
              <v-file-input
                  v-model="files[f]"
                  :id="'file' + f"
                  :rules="rulesFile"
                  color="#F15A29"
                  style="border-radius: 30px"
                  outlined
                  :clearable="false"
                  height="36"
                  placeholder=""
                  prepend-icon=""
                  accept="application/pdf,.doc,.docx"
                  v-show="
                      checkValType(file.file_name) == 'object' ||
                      file.file_name == '' ||
                      file.file_name == null
                    "
                  @change="addToAttachment(files[f],f)"
              ></v-file-input>
              <v-text-field
                  v-show="checkValType(file.file_name) == 'string'"
                  v-model="file.file_name"
                  outlined
                  height="36"
                  color="#F15A29"
                  style="border-radius: 30px"
                  readonly
              ></v-text-field>
            </v-flex>
            <v-flex shrink ml-3>
              <v-btn
                  depressed
                  dark
                  rounded
                  width="100"
                  color="#464647"
                  @click="selectFile(f)"
              >
                <v-icon class="font-12 font-w-700" left>mdi-upload</v-icon>
                <span class="font-12 font-w-700">อัพโหลด</span>
              </v-btn>
            </v-flex>
            <v-flex shrink ml-3>
              <v-btn
                  depressed
                  height="35"
                  width="35"
                  fab
                  dark
                  color="#FD0C0C"
                  @click="removeFile(f)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>

        </div>

        <div v-if="isOIC">
          <v-layout
              align-center
              class="mt-3"
              v-for="(file, f) in attachment"
              :key="f"
          >
            <v-flex shrink class="to-hide">
              <v-btn
                  depressed
                  dark
                  rounded
                  width="125"
                  color="#F15A29"
                  @click="downloadFile(file)"
              >
                <Iconify
                    style="color: #fff"
                    icon="system-uicons:download"
                ></Iconify>
                <span class="font-12 font-w-700">ดาวน์โหลด</span>
              </v-btn>
            </v-flex>
            <v-flex shrink ml-3>
              {{ file.file_name }}
            </v-flex>
          </v-layout>
        </div>

      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../../components/input/TextField"
import SwitchInset from "../../../components/input/SwitchInset"
import AutoBox from "../../../components/input/AutoBox"
import Button from "../../../components/input/Button"
import { eventBus } from "../../../plugins/global-funcs"
import { mapState } from "vuex"
import {apiDomain} from "@/store/constants";
import axios from "axios";

export default {
  name: "AFormAttachment",
  components: {
    TextField,
    SwitchInset,
    AutoBox,
    Button
  },
  props: {
    masterData: {
      default: () => ({})
    },
    isSameId: {
      default: false
    }
  },
  data () {
    return {
      form: [],
      files: [],
      attachment: [{}],
      rulesFile: [
        (value) => !!value || "กรุณาแนบเอกสาร",
        (value) => (!value || value.size <= 50000000) || "ขนาดไฟล์ต้องน้อยกว่า 50 MB!",
      ],
    }
  },
  computed: {
    ...mapState({
      AttachmentForm: state => state.AForm.AttachmentForm,
      isOIC: state => state.Auth.User.user_type === 'สป.อว.'
    })
  },
  watch: {
    files: {
      handler (val) {
        this.form = this.attachment
        console.log('this.form@watch', this.form)
      },
      deep: true
    }
  },
  created () {
    if (this.isSameId && !this.masterData.form_a) this.form = this.AttachmentForm
    eventBus.$on('aFormAttachment', () => {
      eventBus.$emit('aFormAttachmentSend', this.form)
    })

    eventBus.$on('aFormSummary', () => {
      this.$store.commit('AForm/addSummaryData', {
        partFiveAttachment: this.form
      })
    })

    if(this.masterData.form_a.attachments){
      this.setData()
    }
    eventBus.$on('aFormAttachmentSetData', () => this.setData())
  },
  methods: {
    setFormField (field, val) {
      this.form[field] = val
      this.$forceUpdate()
    },
    setData(){
      this.form = this.masterData.form_a.attachments
      this.attachment = []
      //push each of this.masterData.form_c.attachments into this.attachment
      this.masterData.form_a.attachments.forEach((item) => {
        this.attachment.push(item)
      })
    },
    addAttachment () {
      this.attachment.push({})
      this.form = this.attachment
      console.log('addAttachment')
    },
    addToAttachment(file, i){
      console.log('file size', file.size)
      //check if file size > 50mb then show dialog modal
      if(file.size > 50000000){
        this.$store.commit('General/setModal', {
          title: 'ขนาดไฟล์เกิน 50 MB',
          theme: 'warning',
          text: 'กรุณาแนบไฟล์ที่มีขนาดไม่เกิน 50 MB',
          showCancel: false,
          buttonText: 'ตกลง'
        })
        //remove file in to last index of attachment
        this.attachment.pop()
        this.files.pop()
        return
      }
      this.attachment[i] = file
      console.log('addToAttachment', this.attachment)
    },
    removeFile(id) {
      this.attachment.splice(id, 1);
      this.files.splice(id, 1);
      this.form = this.attachment
      console.log('removeFile', this.form)
    },
    selectFile(id) {
      // querySelector id file จากนั้นเรียก event click
      document.querySelector("#file" + id).click();
    },
    checkValType(val) {
      return typeof val;
    },
    downloadFile(file) {
      axios({
        url: `/api/download/${file.id}`,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', file.file_name);
        document.body.appendChild(link);
        link.click();
      })
          .catch((error) => {
            this.$store.commit('General/setModal', {
              title: 'ระบบไม่พบไฟล์ที่ร้องขอ',
              theme: 'warning',
              text: 'กรุณาติดต่อเจ้าหน้าที่',
              showCancel: false,
              buttonText: 'ตกลง'
            })
          });
    },
  }
}
</script>

<style scoped>

</style>